<div *ngIf="showExternalPayment" class="text-green">
  <p class="pt-2">
    {{ 'checkout.summary.info.external_payment' | translate }}
  </p>
</div>
<ng-container
  *ngIf="taxes && !showExternalPayment && isVatDisplayed && !item?.isFree"
>
  <div class="ml-4 mt-1" *ngFor="let detail of taxesDetail?.offers[0]?.details">
    <div class="flex text-vtmn-play-content-quiet" *ngIf="detail?.tax?.rate">
      <p class="flex-1">
        {{
          'checkout.summary.table.column.duty.' + detail.tax.type | translate
        }}
        {{ detail.tax.rate | toPercentage }}
      </p>
      <p class="text-right">
        {{ detail.totalTax | displayPrice: taxes.totalWithoutTax[0]?.currency }}
      </p>
    </div>
  </div>
</ng-container>
